<template>
  <div class="app flex-row align-items-center">
  <b-modal v-model="showModal" hide-footer>
    <b-row>
      <b-col>
        <h3>O Sleeker é exclusivo para quem trabalha com <b>EDUCAÇÃO FÍSICA</b> ou <b>NUTRIÇÃO</b>. </h3>
        <p>Ex.: Personal Trainers, Nutricionistas, donos de Academias ou Boxes, etc.</p>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-button class="mt-3 bg-primary" style="min-height: 30px;" @click="showModal = false" block>Entendi, quero me cadastrar.</b-button>
      </b-col>
    </b-row>
    <br/>
    <br/>
  </b-modal>
    <Tracking/>
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="6" sm="8">
          <b-card no-body class="mx-4">
            <b-card-body class="p-4">
              <b-form>
                <img v-if="logo500x100" v-bind:src="logo500x100" width="100%" style="margin-bottom: 30px;" />
                <b-input-group class="mb-3">
                  <b-input-group-prepend>
                    <b-input-group-text><i class="fa fa-user-o" aria-hidden="true"></i></b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input
                    type="text"
                    class="form-control"
                    placeholder="Nome"
                    @keyup.enter.native="$refs.surname.$el.focus()"
                    v-model="name"
                    autocomplete="name"
                  />
                </b-input-group>
                   <b-input-group class="mb-3">
                  <b-input-group-prepend>
                    <b-input-group-text><i class="fa fa-user-o" aria-hidden="true"></i></b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input
                    type="text"
                    class="form-control"
                    placeholder="Sobrenome"
                    @keyup.enter.native="$refs.email.$el.focus()"
                    v-model="surname"
                    autocomplete="surname"
                  />
                </b-input-group>

                <b-input-group class="mb-3">
                  <b-input-group-prepend>
                    <b-input-group-text>@</b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input
                    type="email"
                    class="form-control"
                    placeholder="Email"
                    @keyup.enter.native="$refs.whatsapp.$el.focus()"
                    v-model="email"
                    autocomplete="email"
                  />
                </b-input-group>

                <b-input-group class="mb-3">
                  <b-input-group-prepend>
                    <b-input-group-text>
                      <i class="fa fa-money"></i>
                    </b-input-group-text>
                  </b-input-group-prepend>
                    <b-form-select v-model="niche">
                      <option value="0">Qual sua área de atuação?</option>
                      <option value="1">Nutrição</option>
                      <option value="2">Educação Física</option>
                      <option value="4">Vida Fitness</option>
                      <option value="3">Outra</option>
                    </b-form-select>
                </b-input-group>

                <b-input-group class="mb-3">
                  <b-input-group-prepend>
                    <b-input-group-text>
                      <i class="icon-phone"></i>
                    </b-input-group-text>
                  </b-input-group-prepend>
                  <the-mask
                    :mask="['(##) ####-####', '(##) #####-####']"
                    type="tel"
                    class="form-control"
                    placeholder="Whatsapp"
                    v-model="whatsapp"
                    @keyup.enter.native="$refs.instagram.$el.focus()"
                    ref="whatsapp"
                  />
                </b-input-group>

                <b-input-group class="mb-3">
                  <b-input-group-prepend>
                    <b-input-group-text>
                      <i class="fa fa-instagram"></i>
                    </b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input
                    type="text"
                    class="form-control"
                    placeholder="Instagram (Opcional)"
                    @keyup.enter.native="$refs.password.$el.focus()"
                    v-model="instagram"
                    autocomplete="coupon"
                    ref="instagram"
                  />
                </b-input-group>

                <b-input-group v-if="coupon" class="mb-3">
                  <b-input-group-prepend>
                    <b-input-group-text>
                      <i class="fa fa-tags"></i>
                    </b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input
                    type="text"
                    class="form-control"
                    placeholder="Bônus"
                    @keyup.enter.native="$refs.password.$el.focus()"
                    v-model="coupon"
                    autocomplete="coupon"
                    ref="coupon"
                  />
                </b-input-group>

                <b-input-group class="mb-3">
                  <b-input-group-prepend>
                    <b-input-group-text>
                      <i class="icon-lock"></i>
                    </b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input
                    type="password"
                    class="form-control"
                    placeholder="Senha"
                    v-model="password"
                    ref="password"
                    @keyup.enter.native="$refs.passwordConfirmation.$el.focus()"
                    autocomplete="new-password"
                  />
                </b-input-group>

                <b-input-group class="mb-4">
                  <b-input-group-prepend>
                    <b-input-group-text>
                      <i class="icon-lock"></i>
                    </b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input
                    type="password"
                    class="form-control"
                    placeholder="Confirmar Senha"
                    @keyup.enter.native="register()"
                    ref="passwordConfirmation"
                    v-model="passwordConfirmation"
                    autocomplete="new-password"
                  />
                </b-input-group>

                <b-input-group v-if="invite" class="mb-3">
                  <b-input-group-prepend>
                    <b-input-group-text>
                      <i class="fa fa-trophy"></i>
                    </b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input
                    type="text"
                    class="form-control"
                    placeholder="Convite"
                    @keyup.enter.native="$refs.password.$el.focus()"
                    value="Você foi convidado e ganhará mais posts"
                    autocomplete="invite"
                    ref="coupon"
                    disabled
                  />
                </b-input-group>
                <b-alert v-if="errorMessage" show variant="danger">{{errorMessage}}</b-alert>
                <b-button variant="success" v-on:click="register()" block>Criar conta</b-button>
              </b-form>
            </b-card-body>
            <b-card-footer class="p-4">
              <b-row>
                <b-col>
                  <b-button block class="btn" to="/pages/login">
                    <span>Já tem uma conta? Faça login!</span>
                  </b-button>
                </b-col>
              </b-row>
            </b-card-footer>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import Tracking from "./../Tracking";
import service from "./../../service";
import Router from "vue-router";
import { TheMask } from "vue-the-mask";

export default {
  name: "Register",
  data: function() {
    return {
      email: "",
      password: "",
      whatsapp: "",
      name: "",
      surname: "",
      passwordConfirmation: "",
      errorMessage: undefined,
      logo500x100: undefined,
      instagram: "",
      coupon: "",
      invite: "",
      niche: 0,
      forbidden: false,
      showModal: true
    };
  },
  methods: {
    register: function() {

      let skipEmailConfirmation = false;

      if (localStorage.skipEmailConfirmation) {
        skipEmailConfirmation = true;
      }
      service
        .register({
          signupData: {
            email: this.email,
            password: this.password,
            whatsapp: this.whatsapp,
            instagram: this.instagram,
            name: this.name,
            surname: this.surname,
            coupon: this.coupon,
            niche: this.niche,
            invite: this.invite,
            userIdentifier: ((localStorage.userIdentifier) ? localStorage.userIdentifier : ""),
            skipEmailConfirmation: skipEmailConfirmation
          }
        })
        .then(result => {
          localStorage.sessionId = result.session._id;
          localStorage.userId = result.session.userId;
          localStorage.userEmail = result.user.email;
          let vm = this;
          let queryParams = "";
          let destinationPage = "/tutorial"

          if (localStorage.destinationAfterLogin) {
            destinationPage = localStorage.destinationAfterLogin;
            localStorage.destinationAfterLogin = "";
          }
          //gtag('event', 'conversion', {
          //    'send_to': 'AW-722097690/ZtqJCM-pveIBEJqsqdgC',
          //    'event_callback': () => {
                if (vm.niche && vm.niche == 1) {
                  queryParams = "?nutricionista=1";
                  vm.$router.push("/tutorial?nutricionista=1");
                } else if (vm.niche && vm.niche == 2) {
                  queryParams = "?personal=1";
                  vm.$router.push("/tutorial?personal=1");
                }

                vm.$router.push(destinationPage + queryParams);
              //}
          //});
        })
        .catch(error => {
          if (error && error.message) {
            this.errorMessage = error.message;
            if (error.forbidden) {
              this.forbidden = true;
              if (error.originalIdentifier) {
                localStorage.userIdentifier = error.originalIdentifier;
              }
            }

          } else {
            this.errorMessage = "Confira os dados e tente novamente.";
          }
        });
    }
  },
  created() {
    if (localStorage.couponName) {
      this.coupon = localStorage.couponName;
    }

    if (localStorage.invite) {
      this.invite = localStorage.invite;
    }

    service.getWhitelabel().then((response) => {
      if (response && response.whitelabel) {
        this.logo500x100 = response.whitelabel.logo500x100;
        this.whitelabelName = response.whitelabel.name;
      }
    });
  },
  components: { TheMask, Tracking }
};
</script>
